import {Injectable} from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Params, UrlSegment} from '@angular/router';
import {ComponentType} from '@angular/cdk/overlay';
import {AccountActivatorComponent} from '../../../components/account-activator/account-activator.component';
import {ResetPasswordComponent} from '../../../components/reset-password/reset-password.component';
import {
  RequestResetPasswordComponent
} from '../../../components/request-reset-password/request-reset-password.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AuthService} from '@service/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordHelperService {

  constructor(private authService: AuthService, private dialog: MatDialog) { }

  public handleHelper(url$: Observable<UrlSegment[]>, params$: Observable<Params>): Observable<null | MatDialogRef<any>> {
    return combineLatest([url$, params$]).pipe(
      map(([url, params]) => {
        const lastPath = url.length ? url[url.length - 1].path : '';
        if (lastPath === 'activation') {
          return this.openHelperSection('activation');
        } else if (lastPath === 'reset') {
          return this.openHelperSection('password', params);
        } else {
          return null;
        }
      })
    );
  }

  private openHelperSection(actionType: 'activation' | 'password', params?: Params): MatDialogRef<any> {
    let component: ComponentType<any>;
    let componentData = {};
    switch (actionType) {
      case 'activation':
        component = AccountActivatorComponent;
        componentData = {
          state: this.authService.userActivationState
        };
        break;
      case 'password':
        if (params && Object.keys(params).length === 1 && Object.keys(params)[0] === 'token') {
          component = ResetPasswordComponent;
          componentData = {token: params.token};
        } else {
          component = RequestResetPasswordComponent;
        }
        break;
    }
    const helper = this.dialog.open(component);
    Object.entries(componentData).forEach(([key, value]) => {
      helper.componentInstance[key] = value;
    });
    return helper;
  }
}
